// file: `react/src/index.js`:

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import App from './ReactApp.tsx';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from "../src/components/UserContext.tsx";
import { CryptoProvider } from "../src/components/CryptoContext.tsx";
import { ChatSocketProvider } from "../src/components/ChatSocketContext.tsx";
import { registerPushServiceWorker } from './utils/pushNotifications.ts';
import axios from 'axios';

axios.defaults.withCredentials = true;

// Set dark mode if user prefers that
function setLightDarkMode(e) {
  const theme = e.matches ? 'dark' : 'light';
  document.documentElement.setAttribute('data-bs-theme', theme);
}

const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');

// Set initial theme
setLightDarkMode(prefersDarkScheme);

// Listen for changes in the OS theme preference
prefersDarkScheme.addEventListener('change', setLightDarkMode);

if ('serviceWorker' in navigator) {
  registerPushServiceWorker().catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <CryptoProvider>
        <ChatSocketProvider>
          <App />
        </ChatSocketProvider>
      </CryptoProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
